import { Component, Vue } from 'vue-property-decorator';
import PageText from '@/components/page/text/Text.vue';

@Component({
  components: { PageText },
  metaInfo() {
    const { description, keywords, title } = this as PageSmartInfo;
    return { description, keywords, title };
  },
})
export default class PageSmartInfo extends Vue {
  // Readonly
  content: string = '';
  description: string = '';
  keywords: string = '';
  title: string = 'Билет в будущее';

  get regionTitle(): string {
    const { regionName } = this.$store.state.regionProfile;
    return regionName ? regionName : '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/ticket/script.ts